import "core-js/modules/es.array.index-of";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "vant/es/lazyload/style";
import _Lazyload from "vant/es/lazyload";
import "vant/es/notice-bar/style";
import _NoticeBar from "vant/es/notice-bar";
import "vant/es/list/style";
import _List from "vant/es/list";
import "vant/es/field/style";
import _Field from "vant/es/field";
import "vant/es/icon/style";
import _Icon from "vant/es/icon";
import "vant/es/collapse-item/style";
import _CollapseItem from "vant/es/collapse-item";
import "vant/es/collapse/style";
import _Collapse from "vant/es/collapse";
import "vant/es/picker/style";
import _Picker from "vant/es/picker";
import "vant/es/col/style";
import _Col from "vant/es/col";
import "vant/es/row/style";
import _Row from "vant/es/row";
import "vant/es/popover/style";
import _Popover from "vant/es/popover";
import "vant/es/checkbox/style";
import _Checkbox from "vant/es/checkbox";
import "vant/es/dropdown-menu/style";
import _DropdownMenu from "vant/es/dropdown-menu";
import "vant/es/dropdown-item/style";
import _DropdownItem from "vant/es/dropdown-item";
import "vant/es/cell-group/style";
import _CellGroup from "vant/es/cell-group";
import "vant/es/button/style";
import _Button from "vant/es/button";
import "vant/es/action-sheet/style";
import _ActionSheet from "vant/es/action-sheet";
import "vant/es/tag/style";
import _Tag from "vant/es/tag";
import "vant/es/empty/style";
import _Empty from "vant/es/empty";
import "vant/es/search/style";
import _Search from "vant/es/search";
import "vant/es/popup/style";
import _Popup from "vant/es/popup";
import "vant/es/circle/style";
import _Circle from "vant/es/circle";
import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import "vant/es/calendar/style";
import _Calendar from "vant/es/calendar";
import "vant/es/sticky/style";
import _Sticky from "vant/es/sticky";
import "vant/es/pull-refresh/style";
import _PullRefresh from "vant/es/pull-refresh";
import "vant/es/count-down/style";
import _CountDown from "vant/es/count-down";
import "vant/es/overlay/style";
import _Overlay from "vant/es/overlay";
import "vant/es/cell/style";
import _Cell from "vant/es/cell";
import "vant/es/datetime-picker/style";
import _DatetimePicker from "vant/es/datetime-picker";
import "vant/es/tab/style";
import _Tab from "vant/es/tab";
import "vant/es/tabs/style";
import _Tabs from "vant/es/tabs";
import "vant/es/swipe-item/style";
import _SwipeItem from "vant/es/swipe-item";
import "vant/es/swipe/style";
import _Swipe from "vant/es/swipe";
import "D:\\work\\Code\\\u9676\u51B6\\new_hundred_web_ts\\hundred_web_ts\\node_modules\\@vue\\babel-preset-app\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "D:\\work\\Code\\\u9676\u51B6\\new_hundred_web_ts\\hundred_web_ts\\node_modules\\@vue\\babel-preset-app\\node_modules\\core-js\\modules\\es.promise.js";
import "D:\\work\\Code\\\u9676\u51B6\\new_hundred_web_ts\\hundred_web_ts\\node_modules\\@vue\\babel-preset-app\\node_modules\\core-js\\modules\\es.object.assign.js";
import "D:\\work\\Code\\\u9676\u51B6\\new_hundred_web_ts\\hundred_web_ts\\node_modules\\@vue\\babel-preset-app\\node_modules\\core-js\\modules\\es.promise.finally.js";
import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
import App from './App.vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import router from './router/index';
import store from './store/index';
import Uploader from '@forzoom/uploader';
import { MobileButton } from '@forzoom/mobile-button'; // import jssdk from '@forzoom/jssdk';

import jssdk from '@/lib/script/jssdk';
import { Popup } from '@forzoom/popup';
import Touch from '@forzoom/touch';
import VueSkeleton from '@/lib/vue/plugins/skeleton/index'; // 暂时不知道是什么

import VueLazyload from 'vue-lazyload';
import Thumbnail from '@forzoom/thumbnail';
import VueRouteScroll from '@forzoom/vue-router-scroll';
import ScrollListener from '@forzoom/scroll-listener';
import { ItemTitle, ItemInput, ItemSelect, ItemCascader, ItemList, ItemButtonGroup, ItemUploader, ItemTextarea, ItemMultiUploader, ItemCommonUploader } from '@forzoom/item-form';
import { CompactInput, CompactSelect, CompactCascader, CompactTextarea } from '@forzoom/compact-form';
import mock from '@/mocks/index';
import './main.less';
import 'lib-flexible';
import 'normalize.css'; // 引入装饰器

import { Component } from 'vue-property-decorator'; // 错误捕获

import './lib/service/sentry';
import VConsole from 'vconsole';
import extendVue from '@/lib/vue/extend';
window.apiUrl = process.env.RO_API_URL;
window.pageUrl = process.env.RO_PAGE_URL;
window.appPageRoot = process.env.RO_APP_PAGE_ROOT;

function report(type, id) {
  if (type === 'page') {
    if (id === ROUTE_NAME.ACTIVITY_SUBMIT_ORDER) {
      var srctag = getQS().srctag;
      var map = {
        'invite_card_common-20200927-01': MTA.ID_FUNNEL_14_INVITE_CARD_1,
        'invite_card_common-20200927-02': MTA.ID_FUNNEL_14_INVITE_CARD_2,
        'invite_card_common-20200927-03': MTA.ID_FUNNEL_14_INVITE_CARD_3,
        'invite_card_common-20200927-04': MTA.ID_FUNNEL_14_INVITE_CARD_4,
        'invite_card_new-common-20200927-01': MTA.ID_FUNNEL_14_INVITE_CARD_5,
        'invite_card_new-common-20201015-01': MTA.ID_FUNNEL_14_INVITE_CARD_6,
        'invite_card_team-0913-01': MTA.ID_FUNNEL_14_TEAM_INVITE_CARD_1,
        'invite_card_team-0913-02': MTA.ID_FUNNEL_14_TEAM_INVITE_CARD_2,
        'invite_card_new-team-20200927-01': MTA.ID_FUNNEL_14_TEAM_INVITE_CARD_3,
        'monitor_invite_card': MTA.ID_FUNNEL_MONITOR_INVITE_CARD_JOIN,
        'cansai4': MTA.ID_FUNNEL_NUMBER_CLOTH,
        'jmsxy': MTA.ID_FUNNEL_14_JMSXY,
        'tesla': MTA.ID_FUNNEL_14_TESLA
      };

      if (map[srctag]) {
        clickStat(map[srctag], {
          enter: true
        });
        var ev = ['_trackEvent', "page", id, srctag];

        _czc.push(ev);

        aplus_queue.push({
          action: 'aplus.record',
          arguments: ['_trackEvent', 'CLK', {
            pagename: "page_" + ROUTE_NAME.ACTIVITY_SUBMIT_ORDER,
            id: id,
            srctag: srctag
          }]
        });
      }

      clickStat(MTA.ID_FUNNEL_JOIN_GENERAL, {
        enter: true
      });
    }
  }
} // 注册钩子


Component.registerHooks(['beforeRouteEnter', 'beforeRouteUpdate', 'beforeRouteLeave']); // 全局混入

Vue.mixin({
  created: function created() {
    report('page', router.currentRoute.name);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.meta && !to.meta.disableShare) {
      // 分享
      enableShareHook(from);
    } // 关闭popup


    var popup = pop();

    if (popup) {
      next(false);
      return;
    }

    next();
  }
}); // 引入工具

import { getQS, imageFilter } from '@/lib/utils';
import { enableShareHook } from './router/hook'; // 提示框

import { del } from './lib/service/storage';
import { KEY_AUTH_TOKEN, loginFn, ROUTE_NAME } from './lib/constant';
import { pop } from './lib/script/popup';
import { clickStat } from '@forzoom/mta';
import MTA from './lib/mta'; // 全局混入

Vue.mixin({
  mounted: function mounted() {
    if (history && history.length) {
      store.commit('setHistoryLength', history.length);
    }
  }
}); // 全局注册组件

Vue.component('MobileButton', MobileButton);
Vue.component('Popup', Popup);
Vue.component('MyPopup', Popup);
Vue.component('Touch', Touch);
Vue.component(_Swipe.name, _Swipe);
Vue.component(_SwipeItem.name, _SwipeItem);
Vue.component(_Tabs.name, _Tabs);
Vue.component(_Tab.name, _Tab);
Vue.component(_DatetimePicker.name, _DatetimePicker);
Vue.component(_Cell.name, _Cell);
Vue.component(_Overlay.name, _Overlay);
Vue.component(_CountDown.name, _CountDown);
Vue.component(_PullRefresh.name, _PullRefresh);
Vue.component(_Sticky.name, _Sticky);
Vue.component(_Calendar.name, _Calendar);
Vue.component(_Dialog.Component.name, _Dialog.Component);
Vue.component(_Circle.name, _Circle);
Vue.component(_Popup.name, _Popup);
Vue.component(_Search.name, _Search);
Vue.component(_Empty.name, _Empty);
Vue.component(_Tag.name, _Tag);
Vue.component(_ActionSheet.name, _ActionSheet);
Vue.component(_Button.name, _Button);
Vue.component(_CellGroup.name, _CellGroup);
Vue.component(_DropdownItem.name, _DropdownItem);
Vue.component(_DropdownMenu.name, _DropdownMenu);
Vue.component(_Checkbox.name, _Checkbox);
Vue.component(_Popover.name, _Popover);
Vue.component(_Row.name, _Row);
Vue.component(_Col.name, _Col);
var components = [ItemTitle, ItemInput, ItemSelect, ItemCascader, ItemList, ItemButtonGroup, ItemUploader, ItemTextarea, ItemMultiUploader, ItemCommonUploader, CompactInput, CompactSelect, CompactCascader, CompactTextarea];

for (var i = 0, len = components.length; i < len; i++) {
  var component = components[i];
  Vue.component(component.name, component);
}

extendVue(); // 创建axios实例

var axiosInstance = axios.create({
  // 设置一个 `baseURL` 便于为 axios 实例的方法传递相对 URL
  baseURL: window.apiUrl,
  // 表示跨域请求时是否需要使用凭证
  withCredentials: true,
  // 超时时间
  timeout: 30000,
  // 有效状态码
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 500;
  }
}); // 响应拦截器

axiosInstance.interceptors.response.use(function (response) {
  // 发生401
  if (response.status === 401) {
    del(KEY_AUTH_TOKEN); // const hasLogin = store.state.auth.hasLogin;
    // 可以用是否登录来对游客状态和登陆失效对应不同的提示👆

    _Dialog.confirm({
      title: '重新登录提示',
      message: '当前处于游客模式，需要登录。',
      confirmButtonText: '立即登录'
    }).then(function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var rdata, status, name;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , loginFn()];

            case 1:
              rdata = _a.sent();
              status = rdata === null || rdata === void 0 ? void 0 : rdata.status;
              name = rdata === null || rdata === void 0 ? void 0 : rdata.name;

              if (status === 0) {
                name && location.replace(name);
              } else if (status === 1) {
                location.replace(name);
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    }); // location.reload();

  }

  return response;
}, function (error) {
  // 连接超时响应
  var message = error.message;

  if (message && message.indexOf('timeout') >= 0) {
    store.commit('startError', {
      type: 'icon',
      icon: '&#xe613;',
      text: '当前网络环境较差'
    });
  }

  return Promise.reject(error);
}); // 同步获取服务器时间

axiosInstance.interceptors.response.use(function syncServerTime(response) {
  if (response && response.data && response.data.timestamp) {
    store.commit('setServerTimestamp', response.data.timestamp);
  }

  return response;
}); // 使用插件

Vue.use(VueAxios, axiosInstance);
Vue.use(Uploader, {
  transformWXLocalImageData: true
});
Vue.use(jssdk, {
  store: store
});
Vue.use(VueSkeleton);
Vue.use(VueLazyload, {
  filter: imageFilter
});
Vue.use(ScrollListener, {
  store: store
});
Vue.use(Thumbnail, {
  imageFilter: imageFilter,
  enterClass: 'image-blur1',
  leaveClass: 'image-blur2'
});
Vue.use(VueRouteScroll, {
  router: router
});
Vue.use(_Picker);
Vue.use(_Collapse);
Vue.use(_CollapseItem);
Vue.use(_Icon);
Vue.use(_Field);
Vue.use(_List);
Vue.use(_NoticeBar);
Vue.use(_Lazyload); // 非生产环境，使用mock数据

if (process.env.NODE_ENV !== 'production') {
  mock();
}

if (process.env.RO_ENV === 'development') {
  new VConsole();
} // 阻止启动生产消息（常用作指令）


Vue.config.productionTip = false;
Vue.config.keyCodes = {
  enter: 13
};
new Vue({
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app');